import { render, staticRenderFns } from "./OrderManage.vue?vue&type=template&id=b2d7d676&scoped=true&"
import script from "./OrderManage.vue?vue&type=script&lang=js&"
export * from "./OrderManage.vue?vue&type=script&lang=js&"
import style0 from "./OrderManage.vue?vue&type=style&index=0&id=b2d7d676&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d7d676",
  null
  
)

export default component.exports